import { BlockReferenceArray } from '@/cms/types/block';

import { FooterStrapiProps } from '@/decodo/blocks/Footer/FooterStrapi';
import { apiCallStrapi } from '@/utils/fetch';

export const fetchFooterData = (documentId: string) =>
  apiCallStrapi<BlockReferenceArray<FooterStrapiProps>>({
    path: `/footers`,
    query: {
      pLevel: 'deep',
      filters: {
        documentId: documentId,
      },
    },
    method: 'GET',
    next: {
      revalidate: 10 * 60,
      tags: [`footer-document-id-${documentId}`],
    },
  });
